var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPaperclip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5,3 C4.5,1.61928813 5.61928813,0.5 7,0.5 C8.38071187,0.5 9.5,1.61928813 9.5,3 L9.5,12 C9.5,12.8284271 8.82842712,13.5 8,13.5 C7.17157288,13.5 6.5,12.8284271 6.5,12 L6.5,5 C6.5,4.72385763 6.72385763,4.5 7,4.5 C7.27614237,4.5 7.5,4.72385763 7.5,5 L7.5,12 C7.5,12.2761424 7.72385763,12.5 8,12.5 C8.27614237,12.5 8.5,12.2761424 8.5,12 L8.5,3 C8.5,2.46410161 8.21410163,1.96891107 7.75000001,1.70096187 C7.28589839,1.43301267 6.71410161,1.43301267 6.24999999,1.70096187 C5.78589837,1.96891107 5.5,2.46410161 5.5,3 L5.5,12 C5.5,13.3807119 6.61928813,14.5 8,14.5 C9.38071187,14.5 10.5,13.3807119 10.5,12 L10.5,5 C10.5,4.72385763 10.7238576,4.5 11,4.5 C11.2761424,4.5 11.5,4.72385763 11.5,5 L11.5,12 C11.5,13.9329966 9.93299662,15.5 8,15.5 C6.06700338,15.5 4.5,13.9329966 4.5,12 L4.5,3 Z",
    transform: "rotate(-45 8 8)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPaperclip);
export default __webpack_public_path__ + "static/media/icon-paperclip.7910f42500a0f924dba02a7ece6a3c31.svg";
export { ForwardRef as ReactComponent };